import { render } from "./GlobalSubscriptionAlert.vue?vue&type=template&id=7228c0ba"
import script from "./GlobalSubscriptionAlert.vue?vue&type=script&lang=js"
export * from "./GlobalSubscriptionAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__